import { useQuery } from '@tanstack/react-query';
import UserService from '../Services/users/UserService';

export const GET_SESSIONS_QUERY_KEY = 'getSessions';

//TODO: implement refresh interval or polling , or stale time
export const useGetSessions = () => {
  return useQuery({
    queryKey: [GET_SESSIONS_QUERY_KEY],
    queryFn: UserService.getDevicesWithSessions,
  });
};